import { z } from 'zod'

export const schema = z.object({
  value_date: z.string(),
  value_date_mo: z.string(),
})

export type SchemaType = z.infer<typeof schema>
